import { render, staticRenderFns } from "./expedientes-edit.vue?vue&type=template&id=5f40f6ac&"
import script from "./expedientes-edit.vue?vue&type=script&lang=js&"
export * from "./expedientes-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports